import {useEffect, forwardRef} from 'react'
import {Route} from 'wouter'
import PropTypes from 'prop-types'

export const Page = forwardRef(({content, title, path}) => {
  const Component = content
  return (
    <Route path={path}>
      <PageContent title={title}>
        <Component />
      </PageContent>
    </Route>
  )
})
Page.displayName = 'Page'

const PageContent = forwardRef(({children, title}, ref) => {
  useEffect(() => {
    document.title = `GivePrism - ${title}`
  }, [title])
  return <div ref={ref}>{children}</div>
})
PageContent.displayName = 'PageContent'

Page.propTypes = {
  content: PropTypes.elementType,
  title: PropTypes.string,
  path: PropTypes.string
}

PageContent.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string
}
